export default class rowTitelGenresFilter {
    /**
     * initialize the title navigation on desktop
     */
    constructor(module) {
        this.module = module;
        this.initrowTitelGenres();
    }

    /**
     * add the navigation buttons to the container and 
     * initialize the listener
     */
    initrowTitelGenres() {
        let sectionTitle = this.module.querySelectorAll('.et_pb_rtl_titles');
        let filterButtons = this.module.querySelectorAll('.filter-buttons .btn');
        sectionTitle[0].classList.add('active');
        filterButtons[0].classList.add('active');

        filterButtons.forEach(btn => {
            btn.addEventListener('click',() => {
                filterButtons.forEach(button => {
                    button.classList.remove('active');
                })
                btn.classList.add('active')
                let btnClass = btn.classList[2];
                sectionTitle.forEach(title => {
                    title.classList.remove('active');
                    if(title.id === btnClass) {
                        title.classList.add('active');
                    }
                })
            })
        });
    }
}